import debugLogger from "../utils/debugLogger";

import { EventHandler } from "./EventTypes";

export class GlobalEventBus {
  private handlers: Map<string, EventHandler[]> = new Map();
  private debugMode: boolean = false;

  subscribe(event: string, handler: EventHandler): string {
    if (this.debugMode) {
      debugLogger.debug(`[GlobalEventBus] Subscribing to event: ${event}`);
    }
    if (!this.handlers.has(event)) {
      this.handlers.set(event, []);
    }
    this.handlers.get(event)!.push(handler);
    return Math.random().toString(36).substr(2, 9);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emit(event: string, payload: any = {}): void {
    if (this.debugMode) {
      debugLogger.debug(`[GlobalEventBus] Emitting event: ${event}`, payload);
    }
    const handlers = this.handlers.get(event);
    if (handlers) {
      handlers.forEach((handler) => {
        try {
          handler(payload);
        } catch (error) {
          debugLogger.error(
            `[GlobalEventBus] Error in handler for event ${event}:`,
            error,
          );
        }
      });
    }
  }

  enableDebug(): void {
    this.debugMode = true;
  }

  disableDebug(): void {
    this.debugMode = false;
  }
}
